import React from "react";
import DeactivateByStudent from "./deactivateByStudent";
import ImageModal from "./imageModal";
import ListRubricModal from "./rubric/listRubricModal";
import CreateRubricModal from "./rubric/createRubricModal";
import SelectRubricModal from "./rubric/selectRubricModal";
import CloseConfirmationModal from "./closeConfirmationModal";
import PreviewRubric from "./rubric/previewRubric";
import "./modal.css";
import GroupWidget from "components/Modals/widgetGroup";
import StationWidget from "./widgetStation";

const ModalMenu = ({ type = "", open = true, close = false,is_placement, ...props  }) => {
  return (
    <>
      {(() => {
        switch (type) {
          case "widgetStation":
            return <StationWidget {...props} />;
          case "widgetGroup":
            return <GroupWidget {...props} />;
          case "deactivateByStudent":
            return <DeactivateByStudent open={open} close={close} {...props} />;
          case "imageModal":
            return <ImageModal open={open} close={close} {...props} />;
          case "listRubricModal":
            return <ListRubricModal open={open} close={close} {...props} />;
          case "createRubricModal":
            return <CreateRubricModal open={open} close={close} {...props} is_placement={is_placement} />;
          case "selectRubricModal":
            return <SelectRubricModal  is_placement={is_placement} {...props} />;
          case "closeConfirmationModal":
            return <CloseConfirmationModal open={open} close={close} {...props} />;
          case "previewRubricModal":
            return <PreviewRubric open={open} close={close} {...props} />;
          default:
            return null;
        }
      })()}
    </>
  );
};

export default ModalMenu;
